export const getImageSrc = (rawText: string) => {
    const images: string[] = [];

    const imageElements = rawText.match(/\[.*?點此大圖.*?\]\(.*?\)/g) || [];

    imageElements.forEach((element) => {
        // get only the source
        let source = '';
        const sourceMatch = element.match(/\[.*?點此大圖.*?\]\((.*?)\)/);

        if (sourceMatch) {
            [, source] = sourceMatch;
            images.push(source);
        }
    });

    return images;
};

export const getAudioSrc = (rawText: string) => {
    const audio: string[] = [];

    const elements = rawText.match(/\[.*?語音導覽.*?\]\(.*?\)/g) || [];

    elements.forEach((element) => {
        // get only the source
        let source = '';
        const sourceMatch = element.match(/\[.*?語音導覽.*?\]\((.*?)\)/);

        if (sourceMatch) {
            [, source] = sourceMatch;
            audio.push(source);
        }
    });

    return audio[0];
};
